export enum BuyerSelectionType {
    IdNda = 1,
    DataNda = 2,
    FinancialModel = 3,
}

export const BuyerSelectionTypeOptions = [
    { value: BuyerSelectionType.IdNda, label: 'Buyer ID NDA' },
    { value: BuyerSelectionType.DataNda, label: 'PIP/PIQ Provision' },
    { value: BuyerSelectionType.FinancialModel, label: 'DFM Provision' },
];
